import { useFlags } from 'launchdarkly-react-client-sdk';

import { useTariffType } from 'components/direct-sales/quote/hooks/useTariffType';

import type { TProduct } from 'api/models/TProduct';

export const useTariffConfig = (product: TProduct) => {
  const { experimentTariffCardConfig } = useFlags();
  const { tariffType } = useTariffType(product);

  return experimentTariffCardConfig[`${tariffType}`] || {};
};
